module["exports"] = [
  "(9##)###-##-##"
];
